export const GENERIC_ERROR = 'Error Desconocido';

export const INVALID_TOKEN = 'INVALID_TOKEN';